import { BadgeProps } from '@/components/ui/badge'

export enum FreeTextAnalysisFlag {
  COMPLAINT = 'potential_complaint',
  VULNERABILITY = 'potential_vulnerability',
}

export const FREE_TEXT_ANALYSIS_FLAG_CONFIG: Record<FreeTextAnalysisFlag, { label: string, badgeVariant: BadgeProps['variant'] }> = {
  [FreeTextAnalysisFlag.COMPLAINT]: {
    label: 'Potential complaint',
    badgeVariant: 'outline_destructive',
  },
  [FreeTextAnalysisFlag.VULNERABILITY]: {
    label: 'Potential vulnerability',
    badgeVariant: 'outline_warning',
  },
}
